/**
 * View Helper Utilities
 *
 * Purpose: Utility functions for view data filtering and transformation
 *
 * Functions:
 * - filterViewsByModel: Filter views by model_id
 * - prepareViewStatusToggleData: Prepare form data for status toggle operation
 *
 * Author: Development Team
 * Created: 2025-01-21 (Refactoring Phase 3)
 */

import { View, ViewFormData } from '../services/metadataService';

/**
 * Filter views by model_id
 */
export function filterViewsByModel(views: View[], modelId: string): View[] {
  if (!modelId) {
    return views;
  }
  return views.filter((view) => view.model_id === modelId);
}

/**
 * Prepare view form data for status toggle operation
 * This is needed because updateView requires full ViewFormData
 */
export function prepareViewStatusToggleData(
  view: View,
  newStatus: 'active' | 'disabled'
): ViewFormData {
  return {
    view_id: view.view_id,
    model_id: view.model_id,
    view_type: (view.view_type || 'table') as 'table' | 'edit-modal' | 'export',
    label: view.label,
    status: newStatus,
    fields: [], // Empty array for status update
  };
}

/**
 * Get the toggled status for a view
 */
export function getToggledStatus(currentStatus: string): 'active' | 'disabled' {
  return currentStatus === 'disabled' ? 'active' : 'disabled';
}
